import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';
//用友--------
//部门
export async function initializeDepartment(params) {
    return post(oaserver+'/initialize/initializeDepartment', params, true);
}
//用户
export async function initializeUser(params) {
    return post(oaserver+'/initialize/initializeUser', params, true);
}
//客户
export async function initializeCustomer(params) {
    return post(oaserver+'/initialize/initializeCustomer', params, true);
}
//供应商
export async function initializeSupplier(params) {
    return post(oaserver+'/initialize/initializeSupplier', params, true);
}
//供应商
export async function initializePz(params) {
    return post(oaserver+'/initialize/initializePz', params, true);
}

//南北--------
//基础银行 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnBank
export async function initializeSnBank(params) {
    return post(oaserver+'/initialize/initializeSnBank', params, true);
}
//公司银行账号 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnCompanyBankAccount
export async function initializeSnCompanyBankAccount(params) {
    return post(oaserver+'/initialize/initializeSnCompanyBankAccount', params, true);
}

//部门 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnDepartment
export async function initializeSnDepartment(params) {
    return post(oaserver+'/initialize/initializeSnDepartment', params, true);
}

//人员、部门人员关系 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnUser
export async function initializeSnUser(params) {
    return post(oaserver+'/initialize/initializeSnUser', params, true);
}

//产品分类 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnProductClassify
export async function initializeSnProductClassify(params) {
    return post(oaserver+'/initialize/initializeSnProductClassify', params, true);
}

//产品规格 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnProductSpecification
export async function initializeSnProductSpecification(params) {
    return post(oaserver+'/initialize/initializeSnProductSpecification', params, true);
}

//客商 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnCustomer
export async function initializeSnCustomer(params) {
    return post(oaserver+'/initialize/initializeSnCustomer', params, true);
}

//客商银行信息 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnCustomerBankAccount
export async function initializeSnCustomerBankAccount(params) {
    return post(oaserver+'/initialize/initializeSnCustomerBankAccount', params, true);
}

//客商联系人信息 http://192.168.8.45:10021/oaserver4.0/initialize/initializeSnCustomerContact
export async function initializeSnCustomerContact(params) {
    return post(oaserver+'/initialize/initializeSnCustomerContact', params, true);
}
